import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CATEGORY_URL, SUB_CATEGORY_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import { useAlert } from "./../alerts/AlertContext";
import AddTaskIcon from "@mui/icons-material/AddTask";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { isEmpty } from "../../Constants/RolesConstants";
import SaveIcon from "@mui/icons-material/Save";

function SubCategoryDialog({
  subCategoryId,
  selectedSubCategoryName,
  callSubCategories,
  componentPermissions,
  actionType,
  isEdit
}) {
  const globaltheme = useTheme();
  const theme = createTheme({
    ...globaltheme,
    components: {
      MuiSelect: {},
    },
  });

  const showAlert = useAlert();
  const [open, setOpen] = React.useState(false);
  const [subCategoryName, setSubCategoryName] = useState("");
  const [desc, setDesc] = useState("");
  const [active, setActive] = useState("true");

  const [category, setCategory] = useState();
  const [categories, setCategories] = useState([]);

  const [subCategory, setSubCategory] = useState({
    name: "",
    description: "",
    category: {},
    active: true
  });

  useEffect(() => {
    getCategories();
  }, []);

  const handleClickOpen = () => {    
    if (isEdit === true) {
      getSubCategory();
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubCategoryNameChange = (event) => {
    setSubCategoryName(event.target.value);
  };

  const handleStatusChange = (event) => {
    setActive(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDesc(event.target.value);
  };

  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };

  const getCategories = async () => {
    await AxiosInstance.get(CATEGORY_URL).then((response) =>
      setCategories(response.data.data)
    );
  };

  const getSubCategory = async () => {
    await AxiosInstance.get(`${SUB_CATEGORY_URL}/${subCategoryId}`).then(
      (response) => {
        var subCategoryData = response.data.data;
        setSubCategory(subCategoryData);
        setCategory(subCategoryData?.category ?.id);
        setSubCategoryName(subCategoryData.name);
        setDesc(subCategoryData.description);
        setActive(subCategoryData.active);
        setOpen(true);
      }
    );
  };


  const handleSave = () => {
    const payload = {};
    payload.name = subCategoryName;
    payload.description = desc;
    payload.active = active;
    payload.category = { id: category };

    if (isEdit) {
      updateSubCategory(payload);
    } else {
      saveSubCategory(payload);
    }
  };

  const saveSubCategory = async (payload) => {  

    await AxiosInstance.post(SUB_CATEGORY_URL, payload)
      .then((response) => {
        showAlert("Sub Category created successfully!", "success");
        callSubCategories();
      })
      .catch((error) => {
        showAlert("Sub Category creation failed!", "error");
        console.error(error);
      });
  };

  const updateSubCategory = async (payload) => {

    await AxiosInstance.put(`${SUB_CATEGORY_URL}/${subCategoryId}`, payload)
      .then((response) => {
        showAlert("Sub Category created successfully!", "success");
        callSubCategories();
      })
      .catch((error) => {
        showAlert("Sub Category updation failed!", "error");
        console.error(error);
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <React.Fragment>
        {subCategoryId === 0 ? (
          <>         
          < Tooltip
            title="Add Sub Category"
            onClick={handleClickOpen}
            style={{
              cursor: "pointer",
              margin: "5px 0px",
              float: "right",
            }}
          >
            <IconButton>
              <AddTaskIcon color="primary" />
            </IconButton>
          </Tooltip>
          </>
  ) : (
    <Link onClick={handleClickOpen}>{selectedSubCategoryName}</Link>
        )
}

<Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              (isEmpty(componentPermissions) ||
                componentPermissions ?.["canUpdate"] ||
                  componentPermissions ?.["canCreate"]) &&
                handleSave();
              handleClose();
            },
            sx: {
              width: 600, // fixed width
              height: 440, // fixed height
              maxWidth: "100%", // optional for responsiveness
              maxHeight: "100%", // optional to prevent overflow
            },
          }}

        >
          <DialogTitle>{actionType} Sub Category</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              noValidate
              autoComplete="off"
              sx={{ "& .MuiTextField-root": { m:1, width: "95%" } }}
            >
              <TextField
                autoFocus
                required
                margin="dense"
                id="rg"
                name="name"
                label="Sub Category Name"
                type="text"
                fullWidth
                variant="outlined"
                value={subCategoryName}
                onChange={handleSubCategoryNameChange}
              />
              <br />
              <TextField
                autoFocus
                id="outlined-multiline-static"
                name="description"
                label="Description"
                placeholder="Enter Description"
                fullWidth
                multiline
                rows={4}
                cols={10}
                value={desc}
                onChange={handleDescriptionChange}
              />
              <br />
              <FormControl variant="outlined" sx={{ m: 1, minWidth: 250 }}>
                <InputLabel id="demo-simple-select-standard-label">
                  Category
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={category}
                  onChange={handleCategoryChange}
                  label="Category"
                >
                  <MenuItem value="">
                    {" "}
                    <em>None </em>{" "}
                  </MenuItem>
                  {categories.map((cat) => (
                    <MenuItem value={cat.id}>{cat.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{  m: 1, minWidth: "47%" }}>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Active
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={active}
                  onChange={handleStatusChange}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions sx = {{ marginBottom:"20px"}}>
            {/* <Button onClick={handleClose}>Cancel</Button> */}
            {actionType === "Add" ? 
              <Button 
                variant="contained"
                type="submit"             
                startIcon={<SaveIcon />}
                sx={{
                  float: "right",
                  minWidth: 150,
                  marginRight: "25px",
                  marginTop: "10px",
                  background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
                  boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
                  "&:hover": {
                    background: "linear-gradient(45deg, #1565c0 30%, #1976d2 90%)",
                  },
                }}>Save</Button> : null}
            {actionType === "Edit" &&
              (isEmpty(componentPermissions) ||
                componentPermissions ?.["canUpdate"]) ? (
                <Button 
                variant="contained"
                type="submit" 
                startIcon={<SaveIcon />} 
                sx={{
                  float: "right",
                  minWidth: 150,
                  marginRight: "25px",
                  marginTop: "10px",
                  background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
                  boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
                  "&:hover": {
                    background: "linear-gradient(45deg, #1565c0 30%, #1976d2 90%)",
                  },
                }}>Save</Button>
              ) : null}
          </DialogActions>
        </Dialog>
      </React.Fragment >
    </ThemeProvider >
  );
}
export default SubCategoryDialog;
